"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const Box_1 = __importDefault(require("@mui/material/Box"));
const CopyrightPanel_styles_1 = __importDefault(require("./CopyrightPanel.styles"));
const CopyrightPanel = ({ logoUrl, label, copyrightText, logoAlt, }) => (react_1.default.createElement(Box_1.default, { sx: CopyrightPanel_styles_1.default.container },
    react_1.default.createElement("img", { src: logoUrl, alt: logoAlt }),
    react_1.default.createElement(Typography_1.default, { sx: CopyrightPanel_styles_1.default.label, "data-testid": "footer-label" }, label),
    react_1.default.createElement(Typography_1.default, { sx: CopyrightPanel_styles_1.default.copyright }, copyrightText)));
exports.default = CopyrightPanel;
